import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { ThemeProvider } from './lib/theme.jsx'
import { CrmProvider } from './lib/crm.jsx'
import { ToastProvider } from './lib/toast.jsx'
import { SpectraIqAuthProvider } from './lib/auth.jsx'
import { ErrorBoundary } from './lib/ErrorBoundary.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider>
      <ToastProvider>
        <SpectraIqAuthProvider>
          <CrmProvider>
            <ErrorBoundary><App /></ErrorBoundary>
          </CrmProvider>
        </SpectraIqAuthProvider>
      </ToastProvider>
    </ThemeProvider>
  </StrictMode>,
)
